import { NewsletterForm } from 'ui/components/3-organisms/NewsletterForm';

export const NewsletterSignupFeature: React.FC<Umbraco.NewsletterSignup> = ({ content }) => <NewsletterForm {...content?.properties} />;
